import dayjs from 'dayjs';

export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';

/** Formats API dates and timestamps without shifting date-only values across time zones. */
export const formatDate = (value?: string | Date | null, fallback = '-'): string => {
  if (!value) return fallback;

  if (typeof value === 'string') {
    const displayDate = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (displayDate) return value;
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : fallback;
};

export const formatDateTime = (value?: string | Date | null, fallback = '-'): string => {
  if (!value) return fallback;

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(`${DISPLAY_DATE_FORMAT} HH:mm`) : fallback;
};
